// import React, { useState, useEffect } from 'react';
// import { toast } from 'sonner';
// import { css } from '@emotion/react';
// import { ClipLoader } from 'react-spinners';
// import { Pie } from 'react-chartjs-2';
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
// import AdminActions from './AdminActions';

// ChartJS.register(ArcElement, Tooltip, Legend);

// const override = css`
//   display: block;
//   margin: 0 auto;
// `;

// const JobStatistics = () => {
//   const [jobs, setJobs] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [page, setPage] = useState(1);
//   const limit = 10; // Match backend limit default
//   const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3008/api/v1/';

//   useEffect(() => {
//     const fetchJobs = async () => {
//       try {
//         const response = await fetch(`${apiUrl}job/allJob?page=${page}&limit=${limit}`, {
//           method: 'GET',
//           headers: {
//             'Authorization': `Bearer ${localStorage.getItem('token')}`,
//           },
//         });
//         const data = await response.json();
//         if (response.ok) {
//           setJobs(data.data || []); // Adjust based on response structure
//         } else {
//           toast.error(data.message || 'Failed to fetch jobs');
//         }
//       } catch (error) {
//         console.error('Fetch Error:', error);
//         toast.error('An error occurred while fetching jobs');
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchJobs();
//   }, [apiUrl, page]);

//   const filteredJobs = jobs.filter(job =>
//     `${job.industry} ${job.jobTitle} ${job.state}`.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   // Process data by industry, state, and month
//   const processJobData = () => {
//     const monthlyStats = {};
//     filteredJobs.forEach(job => { // Use filteredJobs instead of jobs for accurate stats
//       const month = new Date(job.createdAt).toLocaleString('default', { month: 'long', year: 'numeric' });
//       const key = `${job.industry}-${job.state}-${month}`;
//       if (!monthlyStats[key]) {
//         monthlyStats[key] = { totalJobs: 0, totalApplicants: 0, employedApplicants: 0 };
//       }
//       monthlyStats[key].totalJobs += 1;
//       monthlyStats[key].totalApplicants += (job.numberOfApplicant?.length || 0);
//       // Check applications for 'Accepted' status
//       const employed = job.applications?.filter(app => app?.status === 'Accepted') || [];
//       monthlyStats[key].employedApplicants += employed.length;
//     });

//     return monthlyStats;
//   };

//   const jobData = processJobData();
//   const industries = [...new Set(filteredJobs.map(job => job.industry))]; // Use filteredJobs
//   const states = [...new Set(filteredJobs.map(job => job.state))]; // Use filteredJobs

//   // Pie chart data for total jobs by industry
//   const jobPieData = {
//     labels: industries,
//     datasets: [{
//       data: industries.map(industry => filteredJobs.filter(j => j.industry === industry).length), // Use filteredJobs
//       backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40'],
//       hoverOffset: 4,
//     }],
//   };

//   // Pie chart data for employed applicants by industry
//   const employedPieData = {
//     labels: industries,
//     datasets: [{
//       data: industries.map(industry => 
//         Object.values(jobData).filter(stat => stat.industry === industry).reduce((sum, stat) => sum + stat.employedApplicants, 0)
//       ),
//       backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40'],
//       hoverOffset: 4,
//     }],
//   };

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center h-screen bg-gray-900">
//         <ClipLoader color="#f97316" css={override} size={50} />
//       </div>
//     );
//   }

//   return (
//     <div className="p-6 bg-gray-900 min-h-screen text-white">
//       <h1 className="text-3xl font-bold mb-6 text-orange-500">Job Statistics - {jobs.length > 0 ? jobs.length : 0} jobs</h1>
//       <div className="mb-6 flex items-center">
//         <input
//           type="text"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//           placeholder="Search by industry, job title, or state..."
//           className="p-3 border border-gray-700 rounded-md w-full md:w-1/3 bg-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-500"
//         />
//         <button
//           onClick={() => setPage(prev => prev + 1)}
//           className="ml-4 p-2 bg-orange-500 text-white rounded hover:bg-orange-600"
//           disabled={jobs.length < limit}
//         >
//           Next Page
//         </button>
//       </div>
//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
//         <div className="overflow-x-auto shadow-lg rounded-lg">
//           <table className="w-full bg-gray-800 border-collapse">
//             <thead>
//               <tr className="bg-gray-700">
//                 <th className="border-b border-gray-600 p-4 text-left text-orange-400">Industry</th>
//                 <th className="border-b border-gray-600 p-4 text-left text-orange-400">State</th>
//                 <th className="border-b border-gray-600 p-4 text-left text-orange-400">Month</th>
//                 <th className="border-b border-gray-600 p-4 text-left text-orange-400">Job Title</th>
//                 <th className="border-b border-gray-600 p-4 text-left text-orange-400">Total Jobs</th>
//                 <th className="border-b border-gray-600 p-4 text-left text-orange-400">Total Applicants</th>
//                 <th className="border-b border-gray-600 p-4 text-left text-orange-400">Employed Applicants</th>
//               </tr>
//             </thead>
//             <tbody>
//               {Object.entries(jobData).map(([key, stat]) => {
//                 const [industry, state, month] = key.split('-');
//                 // Find a representative job title (using the first job for this key)
//                 const sampleJob = filteredJobs.find(job => 
//                   `${job.industry}-${job.state}-${new Date(job.createdAt).toLocaleString('default', { month: 'long', year: 'numeric' })}` === key
//                 );
//                 const jobTitle = sampleJob ? sampleJob.jobTitle : 'N/A';
//                 return (
//                   <tr key={key} className="border-b border-gray-600 hover:bg-gray-700 transition-colors">
//                     <td className="border-r border-gray-600 p-4">{industry}</td>
//                     <td className="border-r border-gray-600 p-4">{state}</td>
//                     <td className="border-r border-gray-600 p-4">{month}</td>
//                     <td className="border-r border-gray-600 p-4">{jobTitle}</td>
//                     <td className="border-r border-gray-600 p-4">{stat.totalJobs}</td>
//                     <td className="border-r border-gray-600 p-4">{stat.totalApplicants}</td>
//                     <td className="border-r border-gray-600 p-4">{stat.employedApplicants}</td>
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         </div>
//         <div className="grid grid-cols-1 gap-6">
//           <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
//             <h2 className="text-xl font-semibold text-orange-500 mb-4">Total Jobs by Industry</h2>
//             <Pie data={jobPieData} />
//           </div>
//           <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
//             <h2 className="text-xl font-semibold text-orange-500 mb-4">Employed Applicants by Industry</h2>
//             <Pie data={employedPieData} />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default JobStatistics;



import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { css } from '@emotion/react';
import { ClipLoader } from 'react-spinners';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import AdminActions from './AdminActions';

ChartJS.register(ArcElement, Tooltip, Legend);

const override = css`
  display: block;
  margin: 0 auto;
`;

const JobStatistics = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(1);
  const limit = 10; 
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3008/api/v1/';

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await fetch(`${apiUrl}job/allJob?page=${page}&limit=${limit}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          },
        });
        const data = await response.json();
        if (response.ok) {
          setJobs(data.data || []); // Adjust based on response structure
        } else {
          toast.error(data.message || 'Failed to fetch jobs');
        }
      } catch (error) {
        console.error('Fetch Error:', error);
        toast.error('An error occurred while fetching jobs');
      } finally {
        setLoading(false);
      }
    };
    fetchJobs();
  }, [apiUrl, page]);

  const filteredJobs = jobs.filter(job =>
    `${job.industry} ${job.jobTitle} ${job.state}`.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Process data by industry, state, and month
  const processJobData = () => {
    const monthlyStats = {};
    filteredJobs.forEach(job => { // Use filteredJobs instead of jobs for accurate stats
      const month = new Date(job.createdAt).toLocaleString('default', { month: 'long', year: 'numeric' });
      const key = `${job.industry}-${job.state}-${month}`;
      if (!monthlyStats[key]) {
        monthlyStats[key] = { totalJobs: 0, totalApplicants: 0, employedApplicants: 0 };
      }
      monthlyStats[key].totalJobs += 1;
      monthlyStats[key].totalApplicants += (job.numberOfApplicant?.length || 0);
      // Check applications for 'Accepted' status
      const employed = job.applications?.filter(app => app?.status === 'Accepted') || [];
      monthlyStats[key].employedApplicants += employed.length;
    });

    return monthlyStats;
  };

  const jobData = processJobData();
  const industries = [...new Set(filteredJobs.map(job => job.industry))]; // Use filteredJobs
  const states = [...new Set(filteredJobs.map(job => job.state))]; // Use filteredJobs

  // Pie chart data for total jobs by industry
  const jobPieData = {
    labels: industries,
    datasets: [{
      data: industries.map(industry => filteredJobs.filter(j => j.industry === industry).length), // Use filteredJobs
      backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40'],
      hoverOffset: 4,
    }],
  };

  // Pie chart data for employed applicants by industry
  const employedPieData = {
    labels: industries,
    datasets: [{
      data: industries.map(industry => 
        Object.values(jobData).filter(stat => stat.industry === industry).reduce((sum, stat) => sum + stat.employedApplicants, 0)
      ),
      backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40'],
      hoverOffset: 4,
    }],
  };

  // Pie chart data for jobs by state and month
  const stateMonthPieData = {
    labels: states.map(state => `${state} (${new Date().toLocaleString('default', { month: 'long', year: 'numeric' })})`), // Current month-year as example
    datasets: [{
      data: states.map(state => filteredJobs.filter(j => j.state === state).length),
      backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0'],
      hoverOffset: 4,
    }],
  };

    const chartOptions = {
    plugins: {
      legend: {
        labels: {
          generateLabels: (chart) => {
            const data = chart.data;
            return data.labels.map((label, index) => ({
              text: label,
              fillStyle: data.datasets[0].backgroundColor[index],
              strokeStyle: '#fff',
              lineWidth: 1,
              hidden: !chart.getDataVisibility(index),
              index,
              // Apply Tailwind-inspired inline styles
              font: {
                size: 14,
                family: 'Arial',
                style: 'normal',
                weight: '500', // Equivalent to font-semibold
              },
              padding: 10,
              boxWidth: 20,
              boxHeight: 20,
              color: '#fff', 
            }));
          },
          usePointStyle: true,
        },
      },
    },
  };


  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-900">
        <ClipLoader color="#16F96DFF" css={override} size={50} />
      </div>
    );
  }

  return (
    <div className="p-6 bg-gray-900 min-h-screen text-white">
      <h1 className="text-3xl font-bold mb-6 text-green-500">Job Statistics - {jobs.length > 0 ? jobs.length : 0} jobs</h1>
      <div className="mb-6 flex items-center">
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search by industry, job title, or state..."
          className="p-3 border border-gray-700 rounded-md w-full md:w-1/3 bg-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-500"
        />
        <button
          onClick={() => setPage(prev => prev + 1)}
          className="ml-4 p-2 bg-green-500 text-white rounded hover:bg-green-600"
          disabled={jobs.length < limit}
        >
          Next Page
        </button>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
        <div className="overflow-x-auto shadow-lg rounded-lg">
          <table className="w-full bg-gray-800 border-collapse">
            <thead>
              <tr className="bg-gray-700">
                <th className="border-b border-gray-600 p-4 text-left text-green-400">Industry</th>
                <th className="border-b border-gray-600 p-4 text-left text-green-400">State</th>
                <th className="border-b border-gray-600 p-4 text-left text-green-400">Month</th>
                <th className="border-b border-gray-600 p-4 text-left text-green-400">Job Title</th>
                <th className="border-b border-gray-600 p-4 text-left text-green-400">Total Jobs</th>
                <th className="border-b border-gray-600 p-4 text-left text-green-400">Total Applicants</th>
                <th className="border-b border-gray-600 p-4 text-left text-green-400">Employed Applicants</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(jobData).map(([key, stat]) => {
                const [industry, state, month] = key.split('-');
                // Find a representative job title (using the first job for this key)
                const sampleJob = filteredJobs.find(job => 
                  `${job.industry}-${job.state}-${new Date(job.createdAt).toLocaleString('default', { month: 'long', year: 'numeric' })}` === key
                );
                const jobTitle = sampleJob ? sampleJob.jobTitle : 'N/A';
                return (
                  <tr key={key} className="border-b border-gray-600 hover:bg-gray-700 transition-colors">
                    <td className="border-r border-gray-600 p-4">{industry}</td>
                    <td className="border-r border-gray-600 p-4">{state}</td>
                    <td className="border-r border-gray-600 p-4">{month}</td>
                    <td className="border-r border-gray-600 p-4">{jobTitle}</td>
                    <td className="border-r border-gray-600 p-4">{stat.totalJobs}</td>
                    <td className="border-r border-gray-600 p-4">{stat.totalApplicants}</td>
                    <td className="border-r border-gray-600 p-4">{stat.employedApplicants}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
          <div className="bg-gray-800 text-white p-4 rounded-lg shadow-lg">
            <h2 className="text-xl font-semibold text-green-500 mb-2">Jobs by State (This Month)</h2>
            <div className="w-1/2 mx-auto"> {/* Reduce size to half width */}
              <Pie data={stateMonthPieData}  option={chartOptions} />
              
            </div>
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
            <h2 className="text-xl font-semibold text-green-500 mb-4">Total Jobs by Industry</h2>
             <div className="w-2/3 mx-auto">
            <Pie data={jobPieData} />
            </div>
          </div>
          </div>
        <div className="grid grid-cols-1 gap-6">
          
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
            <h2 className="text-xl font-semibold text-green-500 mb-4">Employed Applicants by Industry</h2>
            <Pie data={employedPieData} />
          </div>
        
        </div>
      </div>
    </div>
  );
};

export default JobStatistics;